import { useState, useCallback } from 'react';
import { useWebSocket } from './useWebSocket';

export function useToastNotifications(token) {
  const [notifications, setNotifications] = useState([]);

  const addNotification = (notif) => {
    const id = Date.now();
    setNotifications(prev => [{ ...notif, id }, ...prev].slice(0, 50));
    setTimeout(() => {
      setNotifications(prev => prev.filter(n => n.id !== id));
    }, 5000);
  };
  
  return {
    notifications,
    clear: (id) => setNotifications(prev => prev.filter(n => n.id !== id)),
  };
}